import {
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  getWeek,
  eachDayOfInterval,
} from "date-fns";

import { toPairs, flow } from "lodash";
import { groupBy, sortBy } from "lodash/fp";
import { de } from "date-fns/locale";

export function createMonth(year: number, month: number) {
  const monthStart = new Date(year, month);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
  const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

  return eachDayOfInterval({ start: startDate, end: endDate });
}

export function createWeeksOfMonth(year: number, month: number) {
  // brings the days in the form [weekNumber, Date[]],
  // because its easier to render weeks
  const mapToWeeks = flow(
    // groups the days of the month by their calendar week
    // e.g. { "42": [ "2019-09-01", ...]}
    groupBy<Date>((d) => getWeek(d, { locale: de })),
    // turns the object into key value pairs [ [ "42", ["2019-09-01", ...] ], ...]
    (daysByWeek) => toPairs(daysByWeek),
    // sort by the monday of the week
    sortBy(([_, days]) => days[0].getTime())
  );
  return mapToWeeks(createMonth(year, month));
}
